export const userAgentViewPermission = {
    userAgentView: "user-agent.view",
    userAgentsCreate: "user-agents.create",
    userAgentDelete: "user-agent.delete"
};
